module.exports = __webpack_public_path__ + "img/left-2.b4682573.svg";